import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import { usePageTitle } from '../hooks/usePageTitle';

const ContactUsPage = () => {
    usePageTitle('Signal the House');

    return (
        <div className='wp-singular page-template-default page page-id-8 wp-theme-ppc2'>
            <Navigation />
            <main id="main">
                <div className="container">

                    <section className="hero contact-hero">
                        <div className="kicker">SIGNAL ROUTE • VIRTUAL-ONLY SUPPORT</div>

                        <h1 className="hero-title">
                            Signal the House of <span className="hero-title__name">Velar Games</span>
                        </h1>

                        <p className="hero-lead">
                            Share bugs, ideas, or collaboration requests. Every message helps us keep the house luminous 🕯 —
                            and every reply respects the virtual-only nature of the experience.
                        </p>

                        <div className="hero-actions">
                            <a href="#form" className="play-btn">OPEN THE FORM</a>
                            <a href="#direct" className="play-btn alt">DIRECT LINES</a>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>How to send a clear signal</h2>

                        <div className="panel panel--glass" style={{ marginTop: '1.1rem' }}>
                            <ul className="notice-list">
                                <li>Be specific about the chamber, time, and steps you took.</li>
                                <li>Add context (screenshots or browser details are welcome).</li>
                                <li>Keep ideas focused so we can triage quickly.</li>
                                <li>For partnerships, include goals, timelines, and contact details.</li>
                            </ul>
                            <p className="mini" style={{ margin: '.8rem 0 0' }}>
                                This is a social gaming platform using virtual Credits only — no payments, no withdrawals.
                            </p>
                        </div>

                        <div className="grid-tiles" style={{ margin: '1.1rem 0 1.6rem' }}>
                            <div className="tile">
                                <h3>Support</h3>
                                <p className="mini">Account access, Credits, or general questions.</p>
                            </div>
                            <div className="tile">
                                <h3>Bugs &amp; UI</h3>
                                <p className="mini">Display glitches, broken flows, or confusing steps.</p>
                            </div>
                            <div className="tile">
                                <h3>Partnerships</h3>
                                <p className="mini">Media, content ideas, or collaboration proposals.</p>
                            </div>
                        </div>
                    </section>

                    <section className="content-section" id="form" style={{ paddingTop: 0 }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '.35rem' }}>Signal Form</h2>
                        <p className="section-lead" style={{ textAlign: 'center' }}>
                            Leave your message and we’ll answer as soon as the lanterns catch it.
                        </p>

                        <form id="contact-form" className="contact-form">
                            <div className="form-group">
                                <label htmlFor="contact-name">NAME</label>
                                <input type="text" id="contact-name" name="name" required placeholder="Your calling name" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="contact-email">EMAIL</label>
                                <input type="email" id="contact-email" name="email" required placeholder="you@example.com" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="contact-subject">SUBJECT</label>
                                <input type="text" id="contact-subject" name="subject" required
                                    placeholder="What is this signal about?" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="contact-message">MESSAGE</label>
                                <textarea id="contact-message" name="message" rows="6" required
                                    placeholder="Describe the issue, idea, or request..."></textarea>
                            </div>

                            <button type="submit" className="submit-btn">SEND SIGNAL</button>
                        </form>
                    </section>

                    <section className="content-section" id="direct">
                        <h2>Direct lines to the house</h2>

                        <div className="panel panel--glass" style={{ marginTop: '1.1rem' }}>
                            <div className="grid-tiles">
                                <div className="tile">
                                    <h4>Email</h4>
                                    <p className="mini"><a href="/cdn-cgi/l/email-protection" className="__cf_email__"
                                        data-cfemail="7f161119103f1b1e0d14121e110c161011181e121a0c511c1012">info@Velar.site</a>
                                    </p>
                                </div>

                                <div className="tile">
                                    <h4>Website</h4>
                                    <p className="mini">https://Velar.site</p>
                                </div>
                            </div>

                            <p className="mini" style={{ margin: '1rem 0 0', textAlign: 'center' }}>
                                No deposits, no withdrawals, no cash value — the house is pure virtual entertainment.
                            </p>
                        </div>
                    </section>

                </div>
            </main>
            <Footer />
        </div>
    )
}

export default ContactUsPage